export type ArticleCategory =
  | "animation"
  | "color"
  | "design"
  | "general"
  | "guest"
  | "typography";

const ARTICLE_CATEGORIES: { label: string; value: ArticleCategory }[] = [
  { label: "General", value: "general" },
  { label: "Animation", value: "animation" },
  { label: "Typography", value: "typography" },
  { label: "Color", value: "color" },
  { label: "Design", value: "design" },
  { label: "Guest", value: "guest" },
];

export function groupByCategory<T extends { category: ArticleCategory }>(
  items: T[]
): { items: T[]; label: string }[] {
  return ARTICLE_CATEGORIES.flatMap(({ label, value }) => {
    const group = items.filter((item) => item.category === value);
    return group.length > 0 ? [{ items: group, label }] : [];
  });
}
